//@flow
import { combineReducers } from 'redux';
import {
    FETCH_SHAREDMAILBOXES, SAVE_SHAREDMAILBOXES,
    DELETE_SM_DONE, DELETE_SM_FAILED, DELETE_SM_INIT,
    DELETE_CHAT_INBOX_INIT, DELETE_CHAT_INBOX_FAILED,
    DELETE_CHAT_INBOX_DONE, DELETE_WHATSAPP_INBOX_INIT, 
    DELETE_WHATSAPP_INBOX_FAILED, DELETE_WHATSAPP_INBOX_DONE,
    DELETE_VOICE_INBOX_INIT,
    DELETE_VOICE_INBOX_DONE,
    DELETE_VOICE_INBOX_FAILED
} from '../list/actions';
import { 
    GROUP_TYPE_SET_SUCCESS,
    GROUP_TYPE_SET_FAILED
} from '../verify/actions';

import { UPDATE_SM_DONE, UPDATE_SM_INIT, UPDATE_SM_FAILED, RESET_CHANGES, } from './actions';
import { allSharedMailboxReducer } from '../list/reducers';
import { currentSMReducer } from '../edit/reducers';
import { slaForm } from '../sla/reducers';
import {slaReducer} from '../sla_v2/redux/reducer'
import { customerPortalReducer } from '../customerPortal/redux/reducer';

import {removedConversationReducer} from '../settings/reducer'
import {isTrialDataLoadingReducer, trialFeaturesReducer } from './TrialAddon/redux/reducer'
import { smFeedbackPopupReducer } from '../edit/reducers/smFeedbackPopupReducer';

const isLoadingReducer = (state = false, action) => {
    switch(action.type) {
        case FETCH_SHAREDMAILBOXES: 
        case DELETE_SM_INIT:
        case DELETE_WHATSAPP_INBOX_INIT:
        case  DELETE_CHAT_INBOX_INIT:
        case  DELETE_VOICE_INBOX_INIT:
            return true;
        case UPDATE_SM_INIT:
            if (action.payload) 
                return { isLoading: true, currentAction: action.payload };
            return true;
        case SAVE_SHAREDMAILBOXES:
        case UPDATE_SM_DONE:
        case UPDATE_SM_FAILED:
        case DELETE_SM_DONE:
        case DELETE_SM_FAILED:
        case DELETE_WHATSAPP_INBOX_FAILED:
        case DELETE_WHATSAPP_INBOX_DONE:
        case DELETE_CHAT_INBOX_FAILED:
        case DELETE_CHAT_INBOX_DONE:
        case DELETE_VOICE_INBOX_DONE:
        case DELETE_VOICE_INBOX_FAILED:
            return false;
        default: 
            return state;
    }
}
const hasChanges = (state = false, action) => {
    switch(action.type)  {
        case GROUP_TYPE_SET_SUCCESS:
            return true;
        case RESET_CHANGES: 
        case GROUP_TYPE_SET_FAILED:
            return false;
        default:
            return state;
    }
}
export default combineReducers({
    hasChanges,
    isLoading: isLoadingReducer,
    allSharedMailboxes: allSharedMailboxReducer,
    currentSharedMailbox: currentSMReducer,
    slaFormData: slaForm,
    slaV2: slaReducer,
    customerPortal: customerPortalReducer,
    trialAddon:trialFeaturesReducer,
    loadingTrialData:isTrialDataLoadingReducer,
    settings: combineReducers({
       removedConversation: removedConversationReducer
    }),
    smFeedbackPopup: smFeedbackPopupReducer,
});
